// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__TdRIn","location":"Header_location__hCkoy"};